<template>
  <AdDesignWeb
    v-if="propagationContent === 'web'"
    :id="id"
    :disabled="!canEdit"
    :next-route="nextRoute"
    :prev-route="prevRoute"
    :store-namespace="storeNamespace"
  />
  <!--  <AdDesignFacebook v-else />-->
</template>

<script>
import { get } from "vuex-pathify"

import AdDesignWeb from "./design/AdDesignWeb.vue"
// import AdDesignFacebook from "./design/AdDesignFacebook.vue"

export default {
  name: "AdDesign",
  components: {
    AdDesignWeb,
    // AdDesignFacebook,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  computed: {
    canEdit() {
      return !(this.adId || this.audienceId)
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@`, ["adId", "propagationContent"]),
      ...get(`${storeNamespace}/model@audience`, ["audienceId"]),
    })
  },
}
</script>
